import { Link } from 'react-router-dom';

interface MangaCardProps {
  id: string;
  title: string;
  author: string;
  coverUrl: string;
  category: string;
  categorySlug: string;
  status: '连载中' | '已完结';
  rating: number;
  updateTime: string;
  views: number;
}

export default function MangaCard({
  id,
  title,
  author,
  coverUrl,
  category,
  categorySlug,
  status,
  rating,
  updateTime,
  views,
}: MangaCardProps) {
  const formatViews = (v: number): string => {
    if (v >= 10000) {
      return `${(v / 10000).toFixed(1)}万`;
    }
    return v.toString();
  };

  return (
    <Link
      to={`/manga/${id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={coverUrl}
          alt={`${title} 漫画封面`}
          title={`${title} - 免费漫画在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
            status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute top-2 right-2 bg-background-950/70 text-background-50 text-xs px-2 py-0.5 rounded-full flex items-center gap-1">
          <i className="ri-star-fill text-primary-400 text-[10px]"></i>
          <span>{rating}</span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-heading text-foreground-900 text-sm font-bold truncate group-hover:text-primary-500 transition-colors duration-200">
          {title}
        </h3>
        <p className="text-foreground-500 text-xs mt-1 truncate">{author}</p>
        <div className="flex items-center justify-between mt-2">
          <Link
            to={`/category/${categorySlug}`}
            className="text-xs text-secondary-600 bg-secondary-100 px-2 py-0.5 rounded-full hover:bg-secondary-200 transition-colors"
            onClick={(e) => e.stopPropagation()}
          >
            {category}
          </Link>
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <span className="flex items-center gap-0.5">
              <i className="ri-eye-line text-[10px]"></i>
              {formatViews(views)}
            </span>
          </div>
        </div>
        <p className="text-foreground-400 text-[10px] mt-1.5">
          更新于 {updateTime}
        </p>
      </div>
    </Link>
  );
}